// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__wGs96","amount":"Amount_amount__2pC_u","tip":"Amount_tip__31v8K","tipHeader":"Amount_tipHeader__2NRgx","tipsWrap":"Amount_tipsWrap__2guFD"};